import { useCheckAccountTraits } from '@cmg/auth';

export const useCanViewReports = (): boolean => {
  return useCheckAccountTraits(['DATALAB_REPORTS']);
};
